// extracted by mini-css-extract-plugin
module.exports = {"container":"Mn-z","disabled":"Nn-z","bgBlack":"On-z","content":"Pn-z","countdown":"Qn-z","topCaption":"Rn-z","topHeading":"Sn-z","heading":"Tn-z","copy":"Un-z"};